export default function StripParagraphsFilter(module) {
    angular.module(module || 'app')
        .filter('stripParagraphs', stripParagraphs)

    function stripParagraphs() {
        return function (value) {
            if (!value) {
                return value;
            }
            return value.replaceAll('<p>', '').replaceAll('</p>', '');
        }
    }
}